import React from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';

interface IConfirmGenerateInvoiceDocumentsDialogProps {
    dialogName: string;
    hideDialog: () => void;
    label?: string;
    heading?: string;
    igNumber?: number;
    confirmGenerateIgDocs?: () => void;
}

const ConfirmGenerateInvoiceDocumentsDialog = (props: IConfirmGenerateInvoiceDocumentsDialogProps) => {

    return (
        <Dialog title={props?.heading ? props?.heading : ''} dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '15%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form>
                    ⚠️
                    <label>{!!props?.label ? props?.label + (props?.igNumber ? ' for ' + props?.igNumber : '.') : ''}</label>
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Generate'}
                    onClick={() => props.confirmGenerateIgDocs()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '20%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
            </div>
        </Dialog>
    );
};

export default ConfirmGenerateInvoiceDocumentsDialog;


// WEBPACK FOOTER //
// ./src/components/accounts-payable/dialogs/ConfirmGenerateInvoiceDocumentsDialog.tsx